var map = {
	"./auth.tpl.html": "ptTD",
	"./deckWrapper.tpl.html": "8EtL",
	"./endPresentation.tpl.html": "tmcU",
	"./menuEditor.tpl.html": "yUiY",
	"./menuPresentations.tpl.html": "A3Hp",
	"./menuUser.tpl.html": "cNfP",
	"./quoteChooser.tpl.html": "Bj5J",
	"./themeChooser.tpl.html": "13kh",
	"./welcomeIntro.tpl.html": "ftaF",
	"./welcomeStep.tpl.html": "RGh8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ORc+";